import React, { useState, useEffect } from "react";
import Pagination from "react-js-pagination";
import { ContentTable } from "./ContentTable";
import { useSelector, useDispatch } from "react-redux";
import {
  getListDuNoNhanVay,
  updateDataSearch,
} from "../../../actions/DuNoNhanVay";
import { formatNumber } from "utils/currencyFormat";
export const TableDanhSach = () => {
  const dispatch = useDispatch();
  const listDuNoNhanVayFull = useSelector((state) => state.listDuNoNhanVayFull);
  const dataSearch = useSelector((state) => state.dataSearchDuNoNhanVay);

  console.log(listDuNoNhanVayFull);
  useEffect(() => {
    dispatch(getListDuNoNhanVay(dataSearch));
  }, []);
  return (
    <>
      <div
        className="card border-light mb-3 card-v2"
        style={{
          marginLeft: "15px",
          marginRight: "15px",
        }}
      >
        <div className="card-body card-body-v2">
          <div className="Left808x200 Table-main-new">
            <div className="table-mobile sticky-table-bh2 table-mobile-hover">
              <div className="custom-table-wrapper">
                <div className="table-headers">
                  <div className="custom-table-header flex-basis-14 flex-basis-16-sm">
                    <p className="text-center">
                      STT
                      <br />{" "}
                      <span className="color-do">
                        [ {listDuNoNhanVayFull.TongBanGhi} ]
                      </span>
                    </p>
                  </div>
                  <div className="custom-table-header flex-basis-16 flex-basis-13-6-sm">
                    <p className="text-left">Nhân viên</p>
                  </div>

                  <div className="custom-table-header flex-basis-50 flex-basis-50-4-sm">
                    <p className="text-right">
                      Số dư nợ
                      <br />{" "}
                      <span style={{ color: "#00B69B" }}>
                        {formatNumber(listDuNoNhanVayFull.TongDuNo)}
                      </span>
                    </p>
                  </div>
                  <div className="custom-table-header flex-basis-20 flex-basis-20-sm">
                    <p className="tab-header text-center">
                      Số hợp đồng
                      <br />{" "}
                      <span className="color-red">
                        {listDuNoNhanVayFull.TongHopDong}
                      </span>
                    </p>
                  </div>
                </div>

                <div className="custom-table-body">
                  <ContentTable listDuNoNhanVay={listDuNoNhanVayFull.List} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
